import {Platform} from 'react-native';
import env from 'react-native-config';

let url = 'https://ms-qualif.assurancesaro.mg/';
let publicUrl = 'public/';
let privacyURL = 'https://tools.assurancesaro.mg/privacy.html';
let cgEndPoint = 'api/download/conditions';
let manual = 'api/download/manual';
// TODO - test : remove prod
let montantEditable = '1';
let pdfAsLink = '';
let rcvp = 'rcvp.pdf';
let retraite = 'retraite.pdf';
let scolaire = 'scolaire.pdf';
let voyageNotice = 'manual.pdf';
let voyageConditionGeneral = 'conditions.pdf';

// rapatriement
let noticeRapatriement = 'public/NoticeRapatrius.pdf';
let cgRapatriement = 'api/download/manual-condition-general';

if (Platform.OS === 'web') {
  const {REACT_APP_API_URL, PRIVACY_URL} = process.env;

  url = REACT_APP_API_URL;
  privacyURL = PRIVACY_URL ?? 'https://tools.assurancesaro.mg/privacy.html';
} else {
  const {REACT_APP_API_URL, PRIVACY_URL, MONTANT_EDITABLE, PDF_AS_LINK} = env;
  console.log(MONTANT_EDITABLE);

  url = REACT_APP_API_URL;
  privacyURL = PRIVACY_URL;
  montantEditable = MONTANT_EDITABLE || '';
  pdfAsLink = PDF_AS_LINK || '';
}

export default {
  url,
  baseURL: url,
  apiDocs: `${url}api/common`,
  pathApi: 'api/',
  myprivatekey: 'myprivatekey',
  publicUrl: `${url}${publicUrl}`,
  rcvpPdf: `${url}${publicUrl}${rcvp}`,
  scolairePdf: `${url}${publicUrl}${scolaire}`,
  retraitePdf: `${url}${publicUrl}${retraite}`,
  privacyURL,
  conditionGeneral: `${url}${cgEndPoint}`,
  manual: `${url}${manual}`,
  montantEditable: `${montantEditable}`,
  pdfAsLink: `${pdfAsLink}`,
  noticeRapatriement: `${url}${noticeRapatriement}`,
  cgRapatriement: `${url}${cgRapatriement}`,
  voyageNotice: `${url}${publicUrl}${voyageNotice}`,
  voyageCG: `${url}${publicUrl}${voyageConditionGeneral}`,
};
